// Labels and small formatters shared by the safety and apprenticeship pages.

export const formatDay = iso =>
  iso ? String(iso).slice(0, 10).split("-").reverse().join(".") : "";

export const formatDateTime = (value, lng) =>
  value
    ? new Date(value).toLocaleString(lng === "en" ? "en-GB" : lng || "de-DE", {
        dateStyle: "medium",
        timeStyle: "short"
      })
    : "";

export const LIGHT_COLORS = { red: "error", yellow: "warning", green: "success", grey: "default" };

export const stateLabels = t => ({
  missing: t("Missing"),
  overdue: t("Overdue"),
  due_soon: t("Due soon"),
  ok: t("Up to date"),
  none: t("No expiry")
});

export const qualificationLabels = t => ({
  VORSORGE: t("Occupational medical check-up"),
  ERSTHELFER: t("First aider"),
  STAPLER: t("Forklift driver"),
  HOEHENARBEIT_PSAGA: t("Work at height / fall protection"),
  SCHWEISSER: t("Welder qualification"),
  ELEKTROFACHKRAFT: t("Qualified electrician"),
  EUP: t("Electrically instructed person"),
  SCC: t("SCC certificate"),
  FUEHRERSCHEIN: t("Driving licence check"),
  OTHER: t("Other certificate")
});

export const vorsorgeLabels = t => ({
  pflicht: t("Mandatory check-up"),
  angebot: t("Offered check-up"),
  wunsch: t("Requested check-up")
});

export const measureLabels = t => ({
  S: t("Substitution"),
  T: t("Technical"),
  O: t("Organisational"),
  P: t("Personal protective equipment")
});

export const RISK_COLORS = { high: "error", medium: "warning", low: "success" };

export const riskLabels = t => ({ high: t("High"), medium: t("Medium"), low: t("Low") });

export const assessmentStatusLabels = t => ({
  draft: t("Draft"),
  active: t("In force"),
  archived: t("Archived")
});
